(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["epic-hoodie-faq"] && !Shopify.designMode) return;
  try {
    
  class EpicFaqAccordion extends HTMLElement {
    connectedCallback() {
      this.epicFaqTriggers = Array.from(this.querySelectorAll('.epic-faq__trigger'));
      this.epicFaqMultiple = this.dataset.epicFaqMultiple === 'true';

      this.epicFaqTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.epicFaqOnClick);
        trigger.addEventListener('keydown', this.epicFaqOnKeydown);
      });
    }

    disconnectedCallback() {
      this.epicFaqTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.epicFaqOnClick);
        trigger.removeEventListener('keydown', this.epicFaqOnKeydown);
      });
    }

    epicFaqOnClick = (event) => {
      const trigger = event.currentTarget;
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

      if (willOpen && !this.epicFaqMultiple) {
        this.epicFaqTriggers.forEach((other) => {
          if (other !== trigger) this.epicFaqSetState(other, false);
        });
      }

      this.epicFaqSetState(trigger, willOpen);
    };

    epicFaqOnKeydown = (event) => {
      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      const index = this.epicFaqTriggers.indexOf(event.currentTarget);
      if (index === -1) return;

      const last = this.epicFaqTriggers.length - 1;
      let next = index;

      if (event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;

      event.preventDefault();
      this.epicFaqTriggers[next].focus();
    };

    epicFaqSetState(trigger, open) {
      const item = trigger.closest('.epic-faq__item');
      if (!item) return;

      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.classList.toggle('is-open', open);
    }
  }

  if (!customElements.get('epic-faq-accordion')) {
    customElements.define('epic-faq-accordion', EpicFaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
